import React from 'react'
import PropTypes from 'prop-types'

import T from 'T'
import { Chip, Avatar, useTheme } from '@mui/material'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import { PAYMENT_STATUS } from 'settings/constants/payment'
import { PAYMENT_STATUS_COLORS } from './settings'

const { APPROVED, REVERSED, VOIDED, REFUNDED, DECLINED, TRANSFERRED, FAILED, PENDING, PROCESSED } = PAYMENT_STATUS

const PaymentStatusChip = ({ status = '' }) => {
  const theme = useTheme()
  const getParams = () => {
    if (status === APPROVED) {
      return { label: 'Complete', color: PAYMENT_STATUS_COLORS[APPROVED] }
    }

    if (status === VOIDED) {
      return { label: T.VOIDED, color: PAYMENT_STATUS_COLORS[VOIDED] }
    }

    if (status === REFUNDED) {
      return { label: T.REFUNDED, color: PAYMENT_STATUS_COLORS[REFUNDED] }
    }

    if (status === REVERSED) {
      return { label: T.REVERSED, color: PAYMENT_STATUS_COLORS[REVERSED] }
    }

    if (status === TRANSFERRED) {
      return { label: T.TRANSFER, color: PAYMENT_STATUS_COLORS[TRANSFERRED] }
    }

    if (status === DECLINED) {
      return { label: T.DECLINED, color: PAYMENT_STATUS_COLORS[DECLINED] }
    }

    if (status === FAILED) {
      return { label: T.FAILED, color: PAYMENT_STATUS_COLORS[FAILED] }
    }

    if (status === PENDING) {
      return { label: T.PENDING, color: PAYMENT_STATUS_COLORS[PENDING] }
    }

    if (status === PROCESSED) {
      return { label: T.PROCESSED, color: PAYMENT_STATUS_COLORS[PROCESSED] }
    }

    return { label: status, color: PAYMENT_STATUS_COLORS[DECLINED] }
  }

  const { label, color } = getParams()

  return (
    <Chip
      size="small"
      avatar={
        <Avatar sx={{ backgroundColor: color[500] }}>
          <AttachMoneyIcon sx={{ fontSize: 16, color: theme.palette.common.white }} />
        </Avatar>
      }
      variant="outlined"
      label={label}
      sx={{ fontWeight: 600, border: '1px solid', borderColor: color[500], backgroundColor: color[50], color: color[700] }}
    />
  )
}

PaymentStatusChip.propTypes = {
  status: PropTypes.string,
}

export default PaymentStatusChip
